/**
 * Comprehensive error messages translations
 * Detailed error message UI text
 */

import { LANGUAGES } from '../config';

export const errorMessagesTranslations = {
  [LANGUAGES.EN]: {
    general: 'An error occurred. Please try again.',
    networkError: 'Network error. Please check your internet connection.',
    serverError: 'Server error. Please try again later.',
    notFound: 'Resource not found.',
    unauthorized: 'You are not authorized to perform this action.',
    forbidden: 'Access denied.',
    badRequest: 'Bad request. Please check your input.',
    validationError: 'Validation error. Please check your input.',
    fileUploadError: 'Error uploading file. Please try again.',
    fileDownloadError: 'Error downloading file. Please try again.',
    fileTooLarge: 'File is too large. Maximum size is 10MB.',
    invalidFileType: 'Invalid file type. Please upload a PDF or Word document.',
    sessionExpired: 'Your session has expired. Please log in again.',
    missingFields: 'Please fill in all required fields.',
    passwordMismatch: 'Passwords do not match.',
    weakPassword: 'Password is too weak. Please use a stronger password.',
    emailInUse: 'Email is already in use.',
    invalidEmail: 'Invalid email address.',
    invalidCredentials: 'Invalid email or password.',
    accountLocked: 'Your account has been locked. Please contact support.',
    accountNotActivated: 'Your account has not been activated. Please check your email.',
    accountSuspended: 'Your account has been suspended. Please contact support.',
    accountDeleted: 'Your account has been deleted.',
    paymentFailed: 'Payment failed. Please try again.',
    subscriptionExpired: 'Your subscription has expired. Please renew.',
    noPermission: 'You don\'t have permission to access this page. Your current role is',
    accessDenied: 'Access Denied',
    userPermissions: 'Users can view and manage their own CV and job skills data. They can upload and analyze their CV and job postings, but cannot access other users\' data or company research.',
    managerPermissions: 'Managers can view and manage their own data as well as the data of their direct subordinates. They can access the Team Management page to view their team members\' CV, job skills, and training recommendations.',
    adminPermissions: 'Administrators have full access to all features, including company research, user management, and system configuration. They can view and manage all users\' data.'
  },
  [LANGUAGES.FR]: {
    general: 'Une erreur est survenue. Veuillez réessayer.',
    networkError: 'Erreur réseau. Veuillez vérifier votre connexion internet.',
    serverError: 'Erreur serveur. Veuillez réessayer plus tard.',
    notFound: 'Ressource non trouvée.',
    unauthorized: 'Vous n\'êtes pas autorisé à effectuer cette action.',
    forbidden: 'Accès refusé.',
    badRequest: 'Mauvaise requête. Veuillez vérifier vos saisies.',
    validationError: 'Erreur de validation. Veuillez vérifier vos saisies.',
    fileUploadError: 'Erreur lors du téléchargement du fichier. Veuillez réessayer.',
    fileDownloadError: 'Erreur lors du téléchargement du fichier. Veuillez réessayer.',
    fileTooLarge: 'Le fichier est trop volumineux. La taille maximale est de 10 Mo.',
    invalidFileType: 'Type de fichier non pris en charge. Veuillez télécharger un PDF ou un document Word.',
    sessionExpired: 'Votre session a expiré. Veuillez vous reconnecter.',
    missingFields: 'Veuillez remplir tous les champs obligatoires.',
    passwordMismatch: 'Les mots de passe ne correspondent pas.',
    weakPassword: 'Le mot de passe est trop faible. Veuillez utiliser un mot de passe plus fort.',
    emailInUse: 'L\'email est déjà utilisé.',
    invalidEmail: 'Adresse email non valide.',
    invalidCredentials: 'Email ou mot de passe invalide.',
    accountLocked: 'Votre compte a été verrouillé. Veuillez contacter le support.',
    accountNotActivated: 'Votre compte n\'a pas été activé. Veuillez vérifier votre email.',
    accountSuspended: 'Votre compte a été suspendu. Veuillez contacter le support.',
    accountDeleted: 'Votre compte a été supprimé.',
    paymentFailed: 'Le paiement a échoué. Veuillez réessayer.',
    subscriptionExpired: 'Votre abonnement a expiré. Veuillez le renouveler.',
    noPermission: 'Vous n\'avez pas la permission d\'accéder à cette page. Votre rôle actuel est',
    accessDenied: 'Accès Refusé',
    userPermissions: 'Les utilisateurs peuvent consulter et gérer leurs propres données de CV et de compétences professionnelles. Ils peuvent télécharger et analyser leur CV et leurs offres d\'emploi, mais ne peuvent pas accéder aux données d\'autres utilisateurs ou à la recherche d\'entreprise.',
    managerPermissions: 'Les gestionnaires peuvent consulter et gérer leurs propres données ainsi que celles de leurs subordonnés directs. Ils peuvent accéder à la page de gestion d\'équipe pour consulter les CV, les compétences professionnelles et les recommandations de formation de leurs membres d\'équipe.',
    adminPermissions: 'Les administrateurs ont un accès complet à toutes les fonctionnalités, y compris la recherche d\'entreprise, la gestion des utilisateurs et la configuration du système. Ils peuvent consulter et gérer les données de tous les utilisateurs.'
  }
};
